import React, { useEffect, useState } from 'react';
import { Zap } from 'lucide-react';
import api from '@/api';
import PillHero from './PillHero';

export default function BettingHero() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancel = false;
    (async () => {
      try {
        const res = await api.getBettingMoversToday();
        if (!cancel) setData(res);
      } catch (_e) {
        if (!cancel) setData({ available: false });
      } finally {
        if (!cancel) setLoading(false);
      }
    })();
    return () => { cancel = true; };
  }, []);

  if (loading || !data?.available) return null;

  return (
    <PillHero
      testId="betting-hero"
      Icon={Zap}
      accent="#A855F7"
      title="Tonight's Sharp Movers"
      subtitle="Top 3 by direction consensus × structured signal"
      tiles={(data.tiles || []).map((t) => ({
        label: `${t.region ? t.region + ' · ' : ''}hot ${t.hotness}`,
        primary: t.label,
        badgeDirection: t.direction,
        badgeLabel: (t.direction_raw || t.direction || 'hold').replace('_', ' '),
      }))}
      sourceNote={data.source_note}
    />
  );
}
